import DataTestCenterServices from "../../services/datamaster/data-test-center.service";

export const MasterTC = {
  data() {
    return {
      optionMasterTc : [],
      multi_master_tc : [],
      items_master_tc : [],
    };
  },
  methods: {
    getAllTestCenter() {
        DataTestCenterServices.getDataTestCenter(0,10000000,'default')
        .then(response => {
            this.optionMasterTc = response.data.data.content
            this.items_master_tc = response.data.data.content 
        }).catch(error => {
            // comment console console.log(error)
        })
    }
  }
};